export const TOGGLE_CONTACT_BAR = 'TOGGLE_CONTACT_BAR';

export const toggleContact = (hidden) => (dispatch) => {
  dispatch({
    type: TOGGLE_CONTACT_BAR,
    payload: {
      hidden,
    },
  });
};
